<template>
  <div :class="themeStyleVs === 2 ? 'cl_page black_box' : 'cl_page'">
    <p class="num_main">共{{ total }}个</p>
    <div class="content_main mn_content_main">
      <van-list
        v-model="loading"
        :finished="finished"
        :finished-text="finishedText"
        @load="scrollMn"
      >
        <div class="list_main">
          <div
            class="cl_main"
            v-for="(item, index) in listData"
            :key="index"
            @click.stop="goMnDetails(item)"
          >
            <div class="lose_box" v-if="item.open_status === 0">
              <div class="btn_show">模拟交易已失效</div>
            </div>
            <img
              class="top_img"
              v-if="item.sort_top === 1"
              src="../../assets/image/zdtype.png"
              alt=""
            />
            <div class="top">
              <span class="tit">{{ item.ts_name }}</span>
              <img
                :src="themeStyleVs === 2 ? dian_block : dian"
                alt=""
                @click.stop="yzProp(item, index)"
              />
            </div>
            <div class="cen_main">
              <ul>
                <li>
                  <p :class="item.lastProfit.totalRisk | formateRedGreen">
                    {{ toFixedNum(item.lastProfit.totalRisk * 100, 2, '%') }}
                  </p>
                  <p>创建后收益</p>
                </li>
                <li>
                  <p :class="item.lastProfit.todayRisk | formateRedGreen">
                    {{ toFixedNum(item.lastProfit.todayRisk * 100, 2, '%') }}
                  </p>
                  <p>今日收益</p>
                </li>
                <li>
                  <p>{{ toFixedNum(item.lastProfit.maxRetreatRate * 100, 2, '%') }}</p>
                  <p>当前最大回撤</p>
                </li>
              </ul>
            </div>
            <div class="chart_box" :id="'chartMn' + index"></div>
            <div class="food_box clearfix">
              <span class="time_box">自{{ item.ct.substr(0, 10) }}</span>
              <div class="right_box">
                <span>收益</span>
                <span>沪深</span>
              </div>
            </div>
          </div>
          <van-empty
            v-if="queryShow && listData.length <= 0"
            class="custom-image"
            :image="not_data"
            description="暂未获取到数据"
          />
        </div>
      </van-list>
    </div>
    <van-popup v-model="popupShow" round position="bottom">
      <div class="popup_box">
        <ul class="controls_ul">
          <li v-if="popupData" @click="topMyFavorFn">
            {{ popupData.sort_top && popupData.sort_top === 1 ? '取消置顶' : '置顶' }}
          </li>
          <li @click="renameShow">重命名</li>
          <li @click="closeFn">关闭模拟盘</li>
        </ul>
        <div class="close_box" @click="popupShow = false">取消</div>
      </div>
    </van-popup>
    <van-popup v-model="deletePopupShow" round position="bottom">
      <div class="popup_box">
        <ul class="controls_ul">
          <li @click="deleteFn">删除</li>
        </ul>
        <div class="close_box" @click="deletePopupShow = false">取消</div>
      </div>
    </van-popup>
    <van-dialog
      v-model="show"
      title="重命名"
      :show-cancel-button="false"
      :show-confirm-button="false"
    >
      <div class="rename_main">
        <p>请输入您需要修改的名称：</p>
        <input v-model="name" type="text" placeholder="请输入模拟交易名称" />
        <div class="fod_box">
          <div class="cancel_box" @click="cancelFn">取消</div>
          <div :class="name === '' ? 'confirm_box search_not' : 'confirm_box'" @click="confirmFn">
            确定
          </div>
        </div>
      </div>
    </van-dialog>
    <van-dialog
      v-model="dialogShow"
      message="请您再次确认是否需要关闭模拟交易，模拟交易关闭后，将停止更新及推送，并无法再次开启，但您仍能在我的模拟交易中找到并查看历史信息。"
      cancelButtonColor="#999"
      confirmButtonColor="#286DF7"
      className="dialog_box"
      confirmButtonText="确认关闭"
      showConfirmButton
      showCancelButton
      @confirm="dialogFnConfirm"
    >
    </van-dialog>
    <van-dialog
      v-model="deleteDiaShow"
      message="删除模拟交易后，您无法再查看该模拟交易的历史信息，是否确认删除？"
      cancelButtonColor="#999"
      confirmButtonColor="#286DF7"
      className="dialog_box"
      showConfirmButton
      showCancelButton
      @confirm="delDialogFnConfirm"
    >
    </van-dialog>
  </div>
</template>

<script>
import mixins from '@/mixins/index.js';
import {
  getMyMokpanel,
  topMyMokpanel,
  renameMokpanelById,
  mockpanelClose,
  delMyMokpanel
} from '@/api/my.js';
import { newFangDouFun } from '@/utils/format.js';
export default {
  name: 'Mn',
  mixins: [mixins],
  data() {
    return {
      dian: require('@/assets/image/dian.png'),
      dian_block: require('@/assets/image/blockImg/dian_img.png'),
      ZhangYuShu: window.config.ZhangYuShu,
      hotTacticInterval: null, // 行情中定时器
      total: 0,
      page: 1,
      pageSize: 10,
      listData: [],
      chartList: [],
      popupShow: false,
      deletePopupShow: false,
      popupData: null,
      popupDataIndex: 0,
      show: false,
      name: '',
      queryShow: false,
      not_data: require('../../assets/image/notData.png'),
      themeStyleVs: 1,
      dialogShow: false,
      deleteDiaShow: false,
      loading: false,
      finished: false,
      finishedText: '没有更多了'
    };
  },
  filters: {
    bgColor: function (num) {
      if (num > 0) {
        return 'one_year_box red_bg';
      } else if (num < 0) {
        return 'one_year_box green_bg';
      }
    }
  },
  created() {
    this.themeStyleVs = Number(this.getUrlQuery('themeStyleVs'));
  },
  mounted() {
    this.getData();
    this.loading = true;
    this.$toast.loading({
      message: '加载中...',
      overlay: true,
      duration: 0
    });
  },
  methods: {
    getData: function () {
      let that = this;
      let obj = {
        start: that.page,
        count: that.pageSize
      };
      getMyMokpanel(obj)
        .then((res) => {
          that.queryShow = true;
          that.$toast.clear();
          if (res.err === 200) {
            that.total = res.data.countData ? res.data.countData : 0;
            that.listData = [...that.listData, ...res.data.listData];
            if (res.data.listData.length < 10) {
              //是否已加载完成，加载完成后不再触发load事件
              that.finished = true;
            } else {
              that.loading = false;
              that.page += 1;
              that.finished = false;
            }
            that.$nextTick(function () {
              that.chartFn();
            });
          } else {
            that.finished = true;
            that.loading = true;
            that.finishedText = '';
            that.total = 0;
          }
        })
        .catch(() => {
          that.loading = true;
          that.finished = true;
          that.finishedText = '';
          that.queryShow = true;
          that.$toast.clear();
        });
    },
    // 创建图表
    chartFn: function () {
      let that = this;
      let dataList = that.listData;
      dataList.forEach((item, index) => {
        if (!that.chartList[index]) {
          let chartDom = document.getElementById('chartMn' + index);
          that.chartList[index] = that.$echarts.init(chartDom);
          window.addEventListener('resize', that.resizeHandler);
        }
        let xData = item.lineData.xData;
        let dataSy = item.lineData.profitRate;
        let dataHs = item.lineData.hs300Rate;
        let option = {
          color: ['#286DF7', '#FF770C'],
          grid: {
            left: 0,
            top: 0,
            right: 0,
            bottom: 0
          },
          xAxis: {
            show: false,
            type: 'category',
            data: xData
          },
          yAxis: {
            show: false,
            type: 'value'
          },
          series: [
            {
              symbol: 'none',
              data: dataSy,
              type: 'line',
              smooth: true,
              itemStyle: {
                lineStyle: {
                  color: '#000000' //改变折线颜色
                }
              }
            },
            {
              symbol: 'none',
              data: dataHs,
              type: 'line',
              smooth: true,
              itemStyle: {
                lineStyle: {
                  color: '#FF770C' //改变折线颜色
                }
              },
              markLine: {
                symbol: ['none', 'none'], // none为标线两端的样式为无，可更改
                data: [
                  {
                    silent: false,
                    yAxis: 0, // 表现自定义的位置，可赋值
                    label: {
                      position: 'end', // 表现内容展示的位置
                      formatter: '中文路均值', // 标线展示的内容
                      color: '#8C8C8C', // 展示内容颜色
                      show: false
                    },
                    lineStyle: {
                      type: 'dashed',
                      color: that.themeStyleVs === 2 ? '#6b7687' : 'rgba(0, 0, 0, 0.2)',
                      width: 1
                    } // 样式： 线型、颜色、线宽
                  }
                ]
              }
            }
          ]
        };
        option && that.chartList[index].setOption(option);
      });
    },
    resizeHandler() {
      this.chartList.forEach((item) => {
        if (item) {
          item.resize();
        }
      });
    },
    // 策略滚动处理
    scrollMn: function () {
      let that = this;
      window.clearInterval(that.hotTacticInterval);
      that.hotTacticInterval = null;
      that.loading = true;
      that.$nextTick(function () {
        that.getData();
      });
    },
    // 因子点击显示弹框
    yzProp: function (item, index) {
      let that = this;
      if (item.open_status === 1) {
        that.popupShow = true;
      } else {
        that.deletePopupShow = true;
      }
      that.popupData = item;
      that.popupDataIndex = index;
    },
    // 置顶按钮
    topMyFavorFn: function () {
      let that = this;
      let obj = {
        zj_id: that.popupData.zj_id
      };
      topMyMokpanel(obj).then((res) => {
        if (res.err === 200) {
          that.page = 1;
          that.listData = [];
          that.loading = true;
          that.$nextTick(function () {
            that.queryShow = false;
            that.getData();
            that.$toast(res.msg);
            that.popupShow = false;
          });
        }
      });
    },
    // 重命名弹框
    renameShow: function () {
      this.show = true;
      this.popupShow = false;
      this.name = this.popupData.ts_name;
    },
    // 隐藏重命名弹框
    cancelFn: function () {
      this.show = false;
      this.name = '';
    },
    //点击确定按钮修改重命名弹框
    confirmFn: function () {
      if (this.name === '') {
        this.$toast('请输入名称');
        return;
      }
      renameMokpanelById({ zj_id: this.popupData.zj_id, ts_name: this.name }).then((res) => {
        if (res.err === 200) {
          this.$toast(res.msg);
          this.$set(this.listData[this.popupDataIndex], 'ts_name', this.name);
        } else {
          this.$toast(res.msg);
        }
        this.show = false;
        this.name = '';
      });
    },
    // 关闭模拟交易
    closeFn: function () {
      let that = this;
      that.dialogShow = true;
    },
    dialogFnConfirm: function () {
      this.delFavor();
    },
    // 关闭模拟交易
    delFavor: function () {
      let that = this;
      let data = that.popupData;
      let obj = {
        h_id: data.h_id
      };
      mockpanelClose(obj).then((res) => {
        if (res.err === 200) {
          that.page = 1;
          that.listData = [];
          that.chartList.forEach((item) => {
            if (item) {
              item.dispose();
            }
          });
          that.chartList = [];
          that.queryShow = false;
          that.getData();
          that.$toast(res.msg);
          that.popupShow = false;
        }
      });
    },
    deleteFn: function () {
      let that = this;
      that.deleteDiaShow = true;
    },
    delDialogFnConfirm: function () {
      this.deleteBtn();
    },
    deleteBtn: function () {
      let that = this;
      let obj = {
        zj_id: that.popupData.zj_id
      };
      delMyMokpanel(obj).then((res) => {
        if (res.err === 200) {
          that.page = 1;
          that.total = 0;
          that.loading = true;
          that.listData = [];
          that.chartList.forEach((item) => {
            if (item) {
              item.dispose();
            }
          });
          that.chartList = [];
          that.getData();
          that.$toast(res.msg);
          that.deletePopupShow = false;
        } else {
          that.$toast(res.msg);
        }
      });
    },
    goMnDetails: function (item) {
      let that = this;
      this.gotoUrlInfo('/mnDetail', 'mnDetail', {
        zj_id: item.zj_id,
        type: 'follow',
        sourceType: true,
        themeStyleVs: that.themeStyleVs
      });
    }
  },
  beforeDestroy() {
    let that = this;
    window.clearInterval(that.hotTacticInterval);
    that.hotTacticInterval = null;
    that.chartList.forEach((item) => {
      if (item) {
        item.dispose();
      }
    });
    that.chartList = [];
    window.removeEventListener('resize', this.resizeHandler);
  }
};
</script>
<style lang="less" scoped>
.cl_page {
  width: 100%;
  height: 100%;
  .num_main {
    padding: 8px 0;
    font-size: 12px;
    color: #555;
    padding-left: 12px;
  }
  .content_main {
    width: 100%;
    height: calc(100% - 32px);
    box-sizing: border-box;
    overflow: hidden;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    .list_main {
      width: 100%;
      height: 100%;
    }
    &.mn_content_main {
      padding: 0 12px;
      .cl_main {
        width: 100%;
        background-color: #fff;
        box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.1);
        border-radius: 8px;
        padding: 15px 12px;
        box-sizing: border-box;
        margin-bottom: 8px;
        position: relative;
        box-shadow: 0px 4px 20px 0px rgba(0, 13, 134, 0.1);
        .lose_box {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          background-color: rgba(255, 255, 255, 0.6);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9;
          .btn_show {
            display: inline-block;
            padding: 6px 16px;
            background: rgba(0, 0, 0, 0.4);
            border-radius: 24px;
            color: #fff;
            font-size: 16px;
          }
        }
        .top_img {
          position: absolute;
          top: 5px;
          left: 5px;
          width: 10px;
          height: 10px;
        }
        .top {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 8px;
          .tit {
            font-size: 16px;
            color: #373a4d;
            font-weight: 500;
          }
          img {
            display: inline-block;
            width: 24px;
            height: 24px;
            z-index: 10;
          }
        }
      }
      .list_main {
        height: 100%;
        width: 100%;
        .main {
          margin-bottom: 8px;
        }
        .cen_main {
          width: 100%;
          margin-bottom: 4px;
          ul {
            width: 100%;
            display: flex;
            li {
              width: 106px;
              height: 52px;
              background: #f9f9f9;
              border-radius: 4px;
              margin-right: 4px;
              display: flex;
              align-items: center;
              flex-direction: column;
              justify-content: center;
              &:last-child {
                margin-right: 0;
              }
              p {
                &:first-child {
                  font-size: 16px;
                  // color: #EF3939;
                  font-weight: 500;
                }
                &:last-child {
                  font-size: 12px;
                  color: #999999;
                }
              }
            }
          }
        }
        .chart_box {
          width: 326px;
          height: 52px;
          background-color: #f8f8f8;
          margin-bottom: 2px;
        }
        .food_box {
          width: 100%;
          padding-left: 8px;
          font-size: 12px;
          color: #999999;
          line-height: 14px;
          .time_box {
            float: left;
          }
          .right_box {
            float: right;
            span {
              position: relative;
              &:first-child {
                margin-right: 17px;
                position: relative;
                &::before {
                  background-color: #286df7;
                }
              }
              &:last-child {
                &::before {
                  background-color: #ff770c;
                }
              }
              &::before {
                content: '';
                width: 4px;
                height: 4px;
                border-radius: 50%;
                position: absolute;
                top: 7px;
                left: -8px;
              }
            }
          }
        }
      }
    }
  }
  .popup_box {
    width: 100%;
    padding-top: 20px;
    box-sizing: border-box;
    .controls_ul {
      width: 100%;
      li {
        display: inline-block;
        width: 100%;
        height: 50px;
        line-height: 50px;
        padding-left: 16px;
        font-size: 16px;
        color: #555;
        border-bottom: 1px solid #e5e5e5;
        &:last-child {
          border: none;
        }
      }
    }
    .close_box {
      width: 100%;
      height: 50px;
      border-top: 1px solid #e5e5e5;
      text-align: center;
      line-height: 50px;
      color: #555;
      font-size: 16px;
    }
  }
  .rename_main {
    width: 100%;
    padding: 16px;
    p {
      font-size: 14px;
      color: #555;
      margin-bottom: 4px;
    }
    input {
      width: 100%;
      height: 38px;
      border-radius: 4px;
      border: 0.5px solid #e5e5e5;
      padding-left: 9px;
      font-size: 14px;
      margin-bottom: 32px;
    }
    .fod_box {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      div {
        padding: 8px 45px;
        border-radius: 6px;
      }
      .cancel_box {
        background: #f7f8fa;
        color: #222;
      }
      .confirm_box {
        background: #286df7;
        color: #fff;
      }
      .search_not {
        opacity: 0.5;
      }
    }
  }
}
.black_box {
  .num_main {
    color: #aab9d1;
  }
  .content_main.mn_content_main {
    .cl_main {
      background-color: #181a23;
      box-shadow: 0px 4px 20px 0px rgba(0, 13, 134, 0.1);
      .top {
        .tit {
          color: #e4e9fe;
        }
      }
      .lose_box {
        background: rgba(24, 26, 35, 0.4);
      }
    }
    .list_main {
      .cen_main {
        ul {
          li {
            background-color: #1d202d;
            p {
              &:first-child {
                color: #e4e9fe;
              }
              &:last-child {
                color: #6b7687;
              }
            }
          }
        }
      }
      .chart_box {
        background-color: #1d202d !important;
      }
      .food_box {
        .time_box {
          color: #6b7687;
        }
        .right_box {
          span {
            color: #6b7687;
          }
        }
      }
    }
  }
  .rename_main {
    p {
      color: #aab9d1;
    }
    input {
      border: 0.5px solid rgba(229, 229, 229, 0.2);
      background: #181a23;
      color: #e4e9fe;
    }
    .fod_box {
      .cancel_box {
        background: #1d202d;
        color: #e4e9fe;
      }
      .confirm_box {
        background-color: #3b85fe;
        color: #181a23;
      }
    }
  }
}
</style>
<style></style>
